
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/summit",
      function () {
        return require("private-next-pages/events/summit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/summit"])
      });
    }
  